import { showSuccess, showError } from "@/lib/toastHelpers";
import { useQuery } from "@tanstack/react-query";
import { useApiMutation } from "@/hooks/useApiMutation";
import { apiRequest, queryClient } from "@/lib/queryClient";
import type { StarterMaterial } from "@/lib/types";

interface UseStarterMaterialsOptions {
  onCreateSuccess?: () => void;
  onUpdateSuccess?: () => void;
  onDeleteSuccess?: () => void;
}

export function useStarterMaterials(options?: UseStarterMaterialsOptions) {

  const { data: starterMaterials, isLoading } = useQuery<StarterMaterial[]>({
    queryKey: ["/api/starter-pack/materials"],
  });

  const createMaterialMutation = useApiMutation({
    endpoint: "/api/starter-pack/materials",
    method: "POST",
    invalidate: [["/api/starter-pack/materials"]],
    successMessage: "Starter material created",
    errorMessage: "Failed to create material",
    onSuccess: options?.onCreateSuccess,
  });

  const updateMaterialMutation = useApiMutation({
    endpoint: (vars: { id: string }) => `/api/starter-pack/materials/${vars.id}`,
    method: "PATCH",
    invalidate: [["/api/starter-pack/materials"]],
    successMessage: "Starter material updated",
    errorMessage: "Failed to update material",
    onSuccess: options?.onUpdateSuccess,
  });

  const deleteMaterialMutation = useApiMutation({
    endpoint: (vars: { id: string }) => `/api/starter-pack/materials/${vars.id}`,
    method: "DELETE",
    invalidate: [["/api/starter-pack/materials"]],
    successMessage: "Starter material deleted",
    errorMessage: "Failed to delete material",
    onSuccess: options?.onDeleteSuccess,
  });

  return {
    starterMaterials,
    isLoading,
    materialsLoading: isLoading,
    createMaterialMutation,
    updateMaterialMutation,
    deleteMaterialMutation,
  };
}
